import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6 19h12","key":"svg-0"}],["path",{"d":"M8 12a4 4 0 1 0 8 0a4 4 0 1 0 -8 0","key":"svg-1"}],["path",{"d":"M16 16v-12","key":"svg-2"}],["path",{"d":"M17 5h-4","key":"svg-3"}]]

const IconCurrencyDong = createReactComponent('outline', 'currency-dong', 'CurrencyDong', __iconNode);

export default IconCurrencyDong;